import React from 'react';
import './keyboard-nav.scss';

export const SkipToContent: React.FC = () => {
    return (
        <a href="#main-content" className="skip-to-content">
            Перейти к содержимому
        </a>
    );
};
